const endpoints = {
  saveVCard: "/v1/auth/agency/vcard",
  updateAgencyName: "/v1/auth/agency/user",
  agencySettings: "/v1/auth/agency/settings",
  embedAnalytics: "/v1/auth/agency/lightski_jwt",
  employeeHistory: "/v1/auth/agency/employee/history",
  employee: "/v1/auth/agency/employee/escalation/details",
  employeeUpdate: "/v1/auth/agency/employee/update",
  postRecognition: "/v1/auth/agency/employees/recognition",
  employeeEscalations: "/v1/auth/agency/employee/escalations",
  rosterStats: "/v1/auth/agency/employee/stats-numbers/roster",
  currentStats: "/v1/auth/agency/employee/stats-numbers/current-stats",
  caregiverRoles: "/v1/auth/agency/employee/caregiver-role-list",
  employeeRecognitions: "/v1/auth/agency/employees/recognitions",
  reportsHighlights: "/v1/auth/agency/employee/reports/highlights",
  trendsOverTime: "/v1/auth/agency/employee/retention-weekly-stats",
  inboxSummary: "/v1/auth/agency/employee/stats-numbers/escalations",
  exitSurveySummary: "/v1/auth/agency/dashboards/exit-surveys/summary",
  taskCenterSummary: "/v1/auth/agency/dashboards/task-center/summary",
  escalations: "/v1/auth/agency/dashboards/escalations",
  exitSurveys: "/v1/auth/agency/dashboards/exit-surveys",
  escalationsSummary: "/v1/auth/agency/dashboards/escalations/summary",
  employeeExitSurvey: "/v1/auth/agency/employee/exit-survey",
  followUpEscalation: "/v1/auth/agency/employee/escalations/follow-up",
  escalationReminders: "/v1/auth/agency/employee/escalations/reminders",
  postPublicRecognition: "/v1/auth/agency/employees/recognition/public",
  employeeStatsByRegion: "/v1/auth/agency/employee/stats-numbers/region",
  embedDashboardUrl: "/v1/auth/agency/employees/metabase/dashboard/url",
  branchMetadata: "/v1/auth/agency/branches/metadata",
  supervisorMetadata: "/v1/auth/agency/supervisor/metadata",
  turnoverRateData: "/v1/auth/agency/reports/branch-metrics",
  winsAndOpportunities: "/v1/auth/agency/employee/top-and-bottom-questions",
  escalationVideoTracking: "/v1/auth/agency/surveys/escalation-video-tracking",
  jobRatios: "/v1/auth/agency/employee/ratios",
  serviceLines: "/v1/auth/agency/employees/service-lines",
  jobs: "/v1/auth/agency/jobs",
  tenures: "/v1/auth/agency/employee/tenures",
  surveyHistory: "/v1/auth/agency/surveys/survey_history",
  surveyQuestions: "/v1/auth/agency/surveys/survey_questions",
  categoryAnalysis: "/v1/auth/agency/surveys/category_analysis",
  employeeEscalationTicket: "/v1/auth/agency/employee/employee-escalation-ticket",
  followUpActions: "/v1/auth/agency/employee/follow-up-actions",
  escalationAssignment: "/v1/auth/agency/dashboards/escalations",
};

export default endpoints;
